<mat-slide-toggle [class]="'custom__class-toogle-container ' + customClass" [checked]="checked" [disabled]="disabled"
  [color]="color" [labelPosition]="labelPosition" [name]="name" [required]="required" [aria-label]="ariaLabel"
  (change)="onToggleChange($event)">
  {{ label }}
</mat-slide-toggle>